import { render, staticRenderFns } from "./PositionOptions.vue?vue&type=template&id=edb42a7c"
import script from "./PositionOptions.vue?vue&type=script&lang=js"
export * from "./PositionOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports